import { forwardRef } from 'react'

import styled from 'styled-components'

import './_withHeaderSection.scss'

type WithHeaderProps = {
  headerSection?: React.ReactNode
  children: React.ReactNode
  customClass?: string
  withoutBorder?: boolean
}

const WithHeaderSection = forwardRef<HTMLDivElement, WithHeaderProps>(
  ({ headerSection, children, customClass, withoutBorder }, ref) => {
    return (
      <div ref={ref} className={`whs${customClass ? ` ${customClass}` : ''}`}>
        <div className="whs__wrapper">
{headerSection && (
  <div
    className={`whs__header ${
      withoutBorder ? 'whs__header--withoutborder' : ''
    }`}
  >
    {headerSection}
  </div>
)}
          <Content className="whs__content">{children}</Content>
        </div>
      </div>
    )
  }
)

WithHeaderSection.displayName = 'WithHeaderSection'

const Content = styled.div`
  height: 100%;
`

export default WithHeaderSection